import React, { FC, ReactNode } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export interface ModalFooterProps {
  submitText: string;
  onSubmit: () => void | Promise<void>;
  closeText?: string;
  onClose?: () => void;
  loading?: boolean;
  disabled?: boolean;
  closeIcon?: ReactNode;
  submitIcon?: ReactNode;
  className?: string;
  Extra?: ReactNode;
}

export const ModalFooter: FC<ModalFooterProps> = ({
  loading,
  disabled,
  closeIcon,
  submitIcon,
  closeText,
  submitText,
  onClose,
  onSubmit,
  className = '',
  Extra,
}) => {
  return (
    <div
      className={`mt-4 me-4 d-flex align-items-center ${
        Extra ? 'justify-content-between' : 'justify-content-end'
      } ${className}`}
    >
      {Extra}
      <Stack direction="row" spacing={1} alignItems="center">
        {onClose && (
          <Button disabled={loading} className="me-2" color="secondary" startIcon={closeIcon} onClick={onClose}>
            {closeText}
          </Button>
        )}
        <LoadingButton
          startIcon={submitIcon}
          variant="contained"
          loadingPosition="start"
          onClick={onSubmit}
          disabled={disabled}
          loading={loading}
        >
          {submitText}
        </LoadingButton>
      </Stack>
    </div>
  );
};
